<template>
  <v-dialog v-model="active" width="500" persistent>
    <v-card>
      <v-card-title> Eliminar area </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-3 text-h6">
        Seguro que quiere eliminar el area
        <b>{{ name }}?</b>        
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="cancel()"> Cancelar </v-btn>
        <v-btn color="primary" text @click="agree()"> Aceptar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Cancel",
  props: {
    active: {
      required: true,
    },
    id: {
      required: true,
    },
    name: {
      required: true,
    },
  },
  methods: {
    agree() {
      this.$store.dispatch("deleteArea", this.id);
      this.$emit("update:active", false);
    },
    cancel() {
      this.$emit("update:active", false);
    },
  },
};
</script>
